import React from 'react';
import Checkbox from 'material-ui/Checkbox'
import styles from '../MaterialUi/styles';
import { FormGroup, FormControlLabel } from 'material-ui/Form';

const RFCheckboxField = ({ input, label, customStyle, customLabelStyle }) => (
    <FormGroup row>
      <FormControlLabel
          control={
            <Checkbox
            checked={input.value ? true : false}
            onChange={input.onChange}
          />
          }
          label={label}
        />
    
  </FormGroup> 
)

export default RFCheckboxField;


// WEBPACK FOOTER //
// ./src/components/ReduxFormComps/RFCheckboxField.js